import { Plug, BatteryCharging, Plugs, Check, X } from "@phosphor-icons/react";

const CHARGER_TYPES = ["laptop", "phone", "tablet"];
const BATTERY_TYPES = ["laptop"];

// device: client_device (ticket) | patient | sale.repair_device
export function accessoryItems(device) {
  const d = device || {};
  const et = d.equipment_type || "laptop";
  const cable = !!d.specs?.includes_cable;
  const out = [];
  if (CHARGER_TYPES.includes(et) || d.includes_charger) out.push({ key: "charger", Icon: Plug, ok: !!d.includes_charger, label: d.includes_charger ? "Con cargador" : "Sin cargador" });
  if (BATTERY_TYPES.includes(et) || d.includes_battery) out.push({ key: "battery", Icon: BatteryCharging, ok: !!d.includes_battery, label: d.includes_battery ? "Con batería" : "Sin batería" });
  if (et === "monitor" || cable) out.push({ key: "cable", Icon: Plugs, ok: cable, label: cable ? "Con cable" : "Sin cable" });
  for (const extra of d.accessories || []) {
    if (extra && String(extra).trim()) out.push({ key: `acc-${extra}`, Icon: Check, ok: true, label: String(extra).trim() });
  }
  return out;
}

export default function AccessoryChips({ device, size = "sm", className = "", testid = "accessory-chips" }) {
  const items = accessoryItems(device);
  if (items.length === 0) return null;
  const pad = size === "xs" ? "text-[9px] px-1.5 py-0.5" : "text-[10px] px-2 py-0.5";
  return (
    <div className={`flex flex-wrap gap-1 ${className}`} data-testid={testid}>
      {items.map((a) => (
        <span
          key={a.key}
          className={`inline-flex items-center gap-1 rounded-sm font-bold uppercase tracking-widest border whitespace-nowrap ${pad} ${a.ok ? "bg-emerald-50 text-emerald-700 border-emerald-200" : "bg-[#E0000F]/5 text-[#E0000F] border-[#E0000F]/30"}`}
          data-testid={`${testid}-${a.key}`}
        >
          {a.ok ? <a.Icon size={10} weight="bold" /> : <X size={10} weight="bold" />}
          {a.label}
        </span>
      ))}
    </div>
  );
}
